module.exports = __webpack_public_path__ + "files/cab4439e5957e1236ccf095714345eca.svg";